"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Permissions = void 0;
/*
 * @Author: Ildomar Carvalho
 * @Email:  ildomar.carvalho@accenture.com
 * @Date:   2023-04-20 13:04:42
 */

const Permissions = exports.Permissions = {
  MENU_NAVIGATE: "MENU_NAVIGATE",
  MENU_PRODUCTION: "MENU_PRODUCTION",
  MENU_HISTORY: "MENU_HISTORY",
  MENU_CONFIG: "MENU_CONFIG",
  UI_SIDEBAR_VIEW: "UI_SIDEBAR_VIEW",
  CAN_VIEW_LOGS_GENERAL: "CAN_VIEW_LOGS_GENERAL",
  CAN_VIEW_LOGS_GENERAL_DETAILS: "CAN_VIEW_LOGS_GENERAL_DETAILS",
  CAN_VIEW_LOGS_EDIT_SCREEN: "CAN_VIEW_LOGS_EDIT_SCREEN",
  CAN_EDIT_COMPONENT_STATUS: "CAN_EDIT_COMPONENT_STATUS",
  CAN_EDIT_COMPONENT: "CAN_EDIT_COMPONENT",
  CAN_VIEW_COMPONENT: "CAN_VIEW_COMPONENT",
  CAN_EDIT_COMPONENT_TYPE: "CAN_EDIT_COMPONENT_TYPE",
  CAN_VIEW_COMPONENT_TYPE: "CAN_VIEW_COMPONENT_TYPE",
  CAN_EDIT_COMPONENT_CYCLE: "CAN_EDIT_COMPONENT_CYCLE",
  CAN_VIEW_COMPONENT_CYCLE: "CAN_VIEW_COMPONENT_CYCLE",
  CAN_EDIT_ORG: "CAN_EDIT_ORG",
  CAN_VIEW_ORG: "CAN_VIEW_ORG",
  CAN_EDIT_ORG_BRANCH: "CAN_EDIT_ORG_BRANCH",
  CAN_VIEW_ORG_BRANCH: "CAN_VIEW_ORG_BRANCH",
  CAN_EDIT_PERMISSION: "CAN_EDIT_PERMISSION",
  CAN_VIEW_PERMISSION: "CAN_VIEW_PERMISSION",
  CAN_EDIT_PROD_LINE: "CAN_EDIT_PROD_LINE",
  CAN_VIEW_PROD_LINE: "CAN_VIEW_PROD_LINE",
  CAN_EDIT_PROD_STATION: "CAN_EDIT_PROD_STATION",
  CAN_VIEW_PROD_STATION: "CAN_VIEW_PROD_STATION",
  CAN_EDIT_PRODUCT: "CAN_EDIT_PRODUCT",
  CAN_VIEW_PRODUCT: "CAN_VIEW_PRODUCT",
  CAN_EDIT_PART: "CAN_EDIT_PART",
  CAN_VIEW_PART: "CAN_VIEW_PART",
  CAN_EDIT_ROLE: "CAN_EDIT_ROLE",
  CAN_VIEW_ROLE: "CAN_VIEW_ROLE",
  CAN_EDIT_USER: "CAN_EDIT_USER",
  CAN_VIEW_USER: "CAN_VIEW_USER",
  CAN_EDIT_USER_ROLE: "CAN_EDIT_USER_ROLE",
  CAN_VIEW_USER_ROLE: "CAN_VIEW_USER_ROLE",
  CAN_EDIT_ROLE_PERMISSION: "CAN_EDIT_ROLE_PERMISSION",
  CAN_VIEW_ROLE_PERMISSION: "CAN_VIEW_ROLE_PERMISSION",
  CAN_EDIT_PART: "CAN_EDIT_PART",
  CAN_VIEW_PART: "CAN_VIEW_PART",
  CAN_EDIT_ALERT_USERS: "CAN_EDIT_ALERT_USERS",
  CAN_VIEW_ALERT_USERS: "CAN_VIEW_ALERT_USERS",
  CAN_EDIT_IO_SIGNAL: "CAN_EDIT_IO_SIGNAL",
  CAN_VIEW_IO_SIGNAL: "CAN_VIEW_IO_SIGNAL",
  CAN_EDIT_MODULES: "CAN_EDIT_MODULES",
  CAN_VIEW_MODULES: "CAN_VIEW_MODULES",
  CAN_VIEW_ADDRESS: "CAN_VIEW_ADDRESS",
  CAN_EDIT_ADDRESS: "CAN_EDIT_ADDRESS",
  CAN_VIEW_CYCLE: "CAN_VIEW_CYCLE",
  CAN_EDIT_CYCLE: "CAN_EDIT_CYCLE",
  CAN_VIEW_FILE: "CAN_VIEW_FILE",
  CAN_EDIT_FILE: "CAN_EDIT_FILE",
  CAN_VIEW_FILE_SETTINGS: "CAN_VIEW_FILE_SETTINGS",
  CAN_EDIT_FILE_SETTINGS: "CAN_EDIT_FILE_SETTINGS",
  CAN_VIEW_LOGIN_SETTINGS: "CAN_VIEW_LOGIN_SETTINGS",
  CAN_EDIT_LOGIN_SETTINGS: "CAN_EDIT_LOGIN_SETTINGS",
  CAN_VIEW_FILE_SYSTEM: "CAN_VIEW_FILE_SYSTEM",
  CAN_EDIT_FILE_SYSTEM: "CAN_EDIT_FILE_SYSTEM",
  CAN_VIEW_SYSTEM_MONITORING: 'VIEW SYSTEM MONITORING',
  CAN_VIEW_FILE_TYPE: "CAN_VIEW_FILE_TYPE",
  CAN_EDIT_FILE_TYPE: "CAN_EDIT_FILE_TYPE",
  CAN_VIEW_FILE_IMPORTER: "CAN_VIEW_FILE_IMPORTER",
  CAN_EDIT_FILE_IMPORTER: "CAN_EDIT_FILE_IMPORTER",
  CAN_VIEW_NETWORK_CONFIG: "CAN_VIEW_NETWORK_CONFIG",
  CAN_SET_NETWORK_CONFIG: "CAN_SET_NETWORK_CONFIG",
  CAN_VIEW_NTP_CONFIG: "CAN_VIEW_NTP_CONFIG",
  CAN_SET_NTP_CONFIG: "CAN_SET_NTP_CONFIG",
  CAN_REBOOT_THE_SYSTEM: "CAN_REBOOT_THE_SYSTEM",
  CAN_SHUTDOWN_THE_SYSTEM: "CAN_SHUTDOWN_THE_SYSTEM",
  CAN_DOUBLE_BLIND: "CAN_DOUBLE_BLIND",
  CAN_LOGIN_ON_FTP: "CAN_LOGIN_ON_FTP",
  CAN_VIEW_ROUTE_LIST: "CAN_VIEW_ROUTE_LIST",
  CAN_EDIT_ROUTE_LIST: "CAN_EDIT_ROUTE_LIST",
  CAN_VIEW_FINGER_PRINTER: "CAN_VIEW_FINGER_PRINTER",
  CAN_EDIT_FINGER_PRINTER: "CAN_EDIT_FINGER_PRINTER",
  POLLUX_PERMISSION: "POLLUX_PERMISSION"
};